import Web3 from 'web3';
import { setBlockchain } from '../store/actions/blockchain';

export const configure = async (provider: any) => {
  const web3 = new Web3(provider);
  const currentBlock = await web3.eth.getBlockNumber();
  setBlockchain({ currentBlock });
};
